import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import { BrowserRouter } from 'react-router-dom'
import SessionStorage from './util/sessionstore'
import { ApolloProvider } from '@apollo/client/react'
import client from './services/apollo'
import ToastContainerWrapper from './component/toast/toast.wrapper'
import 'driver.js/dist/driver.css'

const session = new SessionStorage()

let profile = session.getProfile()
let initialState = profile ? { profile } : undefined

const store = configureStore(initialState)
window.redux_store = store
// console.log(store.getState()) ;

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <App />
        <ToastContainerWrapper />
      </ApolloProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
